import Vue from 'vue'
import Router from 'vue-router'
import PreInscripcion from '@/views/preinscripcion'
import Impresiones from '@/views/Impresiones'
import FormularioInscripcion from '@/views/FormularioInscripcion'
import NotFound from '@/views/NotFound'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/registro/:key/',
      name: 'PreInscripcion',
      component: PreInscripcion
    },
    {
      path: '/registro/:key/:id',
      name: 'PreInscripcion',
      component: PreInscripcion
    },
    {
      path: '/:key/imprimir/:codigo',
      name: 'Impresiones',
      component: Impresiones
    },
    {
      path: '/:key/formulario_inscripcion/:codigo',
      name: 'FormularioInscripcion',
      component: FormularioInscripcion
    },
    {
      path: '/not_found',
      name: 'NotFound',
      meta: { notKey: true },
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  /**/
  if(!to.meta.notKey){
    if(to.params.key){
      next()
    }else{
      next({ path: '/not_found' });
    }
  }else{
    next()
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js